import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn, Router } from '@angular/router';
import { API_ENDPOINT } from '../constants/api-endpoint.constants';
import { ClientService } from '../services/client.service';
import { ApiService } from '../services/api.service';
import { checkRouteAuthorization } from '../utils/route-auth.utils';

const routeCheckAccessMap: Record<string, string> = {
  'learningSourceMaster': 'learningSourceMaster',
  'learningElementMaster': 'learningElementMaster',
  'learningPathMaster': 'learningPathMaster',
  'integrations/app': 'integrations',
  'gamification/editBadge/:badgeId': 'gamification',
  'gamification/createNewBadge': 'gamification',
  'gamification/createNewRule': 'gamification',
  'gamification/editRule/:ruleId': 'gamification'
};

export const adminRouteAuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const clientService = inject(ClientService);
  const router = inject(Router);

  return checkRouteAuthorization(route, state, router, clientService, routeCheckAccessMap, 'admin');
};

export const adminGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const api = inject(ApiService);
  const clientService = inject(ClientService);
  const router = inject(Router);

  const user = clientService.user();
  const hasAdminAccess = clientService.isGlobalAdmin() || Boolean(user?.role?.features?.admin);
  if (!user) {
    router.navigate(['']);
    return false;
  }
  if (!hasAdminAccess) {
    router.navigate(['/accessDenied']);
    return false;
  }

  if (clientService.isGlobalAdmin()) {
    const clientId = localStorage.getItem('currentAdminClientId');
    if (!clientId) {
      router.navigate(['globalAdmin/clients']);
      return false;
    }

    const adminClientApi = api.apiSignal({
      url: API_ENDPOINT.GET_COMPANY_INFO,
      body: { clientId }
    });

    while (adminClientApi.isLoading()) {
      await new Promise(resolve => setTimeout(resolve, 150));
    }

    if (adminClientApi.error()) {
      console.error('Admin data load failed', adminClientApi.error());
      return false;
    }

    const data = adminClientApi.value();
    clientService.client.set(data.client);
  }

  return checkRouteAuthorization(route, state, router, clientService, routeCheckAccessMap, 'admin');
};
